<template>
  <div id="app" class="h-100" :class="[skinClasses]">
    <component :is="layout">
      <router-view :key="$route.fullPath" />
    </component>

    <scroll-to-top v-if="enableScrollToTop" />
  </div>
</template>

<script>
import ScrollToTop from "@core/components/scroll-to-top/ScrollToTop.vue";
// This will be populated in `beforeCreate` hook
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { $themeColors, $themeBreakpoints, $themeConfig } from "@themeConfig";
import { provideToast } from "vue-toastification/composition";
import { watch } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";

import { getMessaging, onMessage, getToken } from "firebase/messaging";
import { useWindowSize, useCssVar } from "@vueuse/core";
import { mapActions, mapGetters } from "vuex";

import store from "@/store";

const LayoutVertical = () => import("@/layouts/vertical/LayoutVertical.vue");
const LayoutHorizontal = () => import("@/layouts/horizontal/LayoutHorizontal.vue");
const LayoutFull = () => import("@/layouts/full/LayoutFull.vue");

export default {
  components: {
    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,

    ScrollToTop,
  },
  // ! We can move this computed: layout & contentLayoutType once we get to use Vue 3
  // Currently, router.currentRoute is not reactive and doesn't trigger any change
  computed: {
    layout() {
      if (this.$route.meta.layout === "full") return "layout-full";
      return `layout-${this.contentLayoutType}`;
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type;
    },
    ...mapGetters({
      unreadNotificationsCount: "auth/getUnreadNotificationsCount",
    }),
  },
  methods: {
    async loginFirebase() {
      const token = await getToken(this.$messaging, {
        vapidKey:
          "BNDWL22h5u86XIi7r1IeAEhHEGzt3XT8VgZnq8CAYzP7_Rt5ID_S59YpZ9Ca5mn3ftGmmP6gUe6eXGOZH_1mkKo",
      });
      localStorage.setItem("fcmid", token);
    },
    sendNotification(payload) {
      this.appendNotification(payload);
      this.toast({
        component: ToastificationContent,
        props: {
          title: payload.notification.title,
          text: payload.notification.body,
          icon: "BellIcon",
        },
      });
    },
    appendNotification(payload) {
      this.updateNotificationsCount(this.unreadNotificationsCount + 1);
      this.pushNotification({
        data: {
          title: payload.notification.title,
          body: payload.notification.body,
        },
        createdAt: new Date(),
      });
    },
    ...mapActions({
      updateNotificationsCount: "auth/updateUnreadNotificationsCount",
      pushNotification: "auth/addNewNotification",
    }),
  },
  mounted() {
    this.loginFirebase();
    onMessage(this.$messaging, (payload) => {
      if (payload && payload.notification) {
        this.sendNotification(payload);
      }
    });
  },
  beforeCreate() {
    // Set colors in theme
    const colors = [
      "primary",
      "secondary",
      "success",
      "info",
      "warning",
      "danger",
      "light",
      "dark",
    ];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(`--${colors[i]}`, document.documentElement).value.trim();
    }

    // Set Theme Breakpoints
    const breakpoints = ["xs", "sm", "md", "lg", "xl"];

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = Number(
        useCssVar(`--breakpoint-${breakpoints[i]}`, document.documentElement).value.slice(0, -2)
      );
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout;
    document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
  },
  methods: {
    async loginFirebase() {
      const token = await getToken(this.$messaging, {
        vapidKey:
          "BNDWL22h5u86XIi7r1IeAEhHEGzt3XT8VgZnq8CAYzP7_Rt5ID_S59YpZ9Ca5mn3ftGmmP6gUe6eXGOZH_1mkKo",
      });
      localStorage.setItem("fcmid", token);
    },
    sendNotification(payload) {
      this.toast({
        component: ToastificationContent,
        props: {
          title: payload.notification.title,
          text: payload.notification.body,
          icon: "BellIcon",
        },
      });
    },
  },
  setup() {
    const { skin, skinClasses } = useAppConfig();
    const { enableScrollToTop } = $themeConfig.layout;

    // If skin is dark when initialized => Add class to body
    if (skin.value === "dark") document.body.classList.add("dark-layout");

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 4000,
      transition: "Vue-Toastification__fade",
    });

    // Set Window Width in store
    store.commit("app/UPDATE_WINDOW_WIDTH", window.innerWidth);
    const { width: windowWidth } = useWindowSize();
    watch(windowWidth, (val) => {
      store.commit("app/UPDATE_WINDOW_WIDTH", val);
    });
    const toast = useToast();

    return {
      skinClasses,
      enableScrollToTop,
      toast,
    };
  },
};
</script>
<style scoped>
.Vue-Toastification__container {
  z-index: 55555;
}
</style>
